export default __webpack_public_path__ + "static/media/portfolio-apple-music.bf32f84b.png";